// Modals are opened by name (ModalName type), not by component reference,
// to avoid circular dependencies between action files and modal components.
import { markRaw } from "vue";

import { valueIn } from "@/utils/record";

const modals = {
  ArtModal: () => import("./ArtModal.vue"),
  ConfirmSyncBacklogModal: () => import("./ConfirmSyncBacklogModal.vue"),
  ConfirmSyncIterationModal: () => import("./ConfirmSyncIterationModal.vue"),
  MirrorModal: () => import("./MirrorModal.vue"),
  OverviewModal: () => import("./OverviewModal.vue"),
  SessionSelectionModal: () => import("./sessionSelection/SessionSelectionModal.vue"),
  ShortcutsModal: () => import("./shortcuts/ShortcutsModal.vue"),
  TeamModal: () => import("./TeamModal.vue"),
  TeamObjectivesModal: () => import("./TeamObjectivesModal.vue"),
  BreakdownModal: () => import("./BreakdownModal.vue"),
  MapModal: () => import("./MapModal.vue"),
  ConfidenceVoteDashboardModal: () =>
    import("./confidenceVote/dashboard/ConfidenceVoteDashboardModal.vue"),
  ConfidenceVoteSessionModal: () =>
    import("./confidenceVote/session/ConfidenceVoteSessionModal.vue"),
  FlexModal: () => import("./flex/FlexModal.vue"),
  ArtKanbanModal: () => import("./kanban/ArtKanbanModal.vue"),
  IterationKanbanModal: () => import("./kanban/IterationKanbanModal.vue"),
  SolutionKanbanModal: () => import("./kanban/SolutionKanbanModal.vue"),
  LinkModal: () => import("./link/LinkModal.vue"),
  TeamMetricsModal: () => import("./metrics/TeamMetricsModal.vue"),
  ArtMetricsModal: () => import("./metrics/ArtMetricsModal.vue"),
  PlanReadoutModal: () => import("./planReadout/PlanReadoutModal.vue"),
  SettingsModal: () => import("./settings/SettingsModal.vue"),
  SightlineResultDialog: () => import("./SightlineResultDialog.vue"),
};

export type ModalName = keyof typeof modals;

export async function loadModal(name: string) {
  if (Object.hasOwn(modals, name)) {
    const { default: component } = await valueIn(modals, name)!();
    return markRaw(component);
  }
}
